import { render, staticRenderFns } from "./AdminChatBaloon.vue?vue&type=template&id=588275ac&scoped=true&"
import script from "./AdminChatBaloon.vue?vue&type=script&lang=js&"
export * from "./AdminChatBaloon.vue?vue&type=script&lang=js&"
import style0 from "./AdminChatBaloon.vue?vue&type=style&index=0&id=588275ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588275ac",
  null
  
)

export default component.exports